import React, { createContext, useState, useContext, useEffect } from 'react';

const AssessmentContext = createContext();

export const useAssessment = () => useContext(AssessmentContext);

export const AssessmentProvider = ({ children }) => {
  const [businessInfo, setBusinessInfo] = useState(null);
  const [answers, setAnswers] = useState({});
  const [currentStep, setCurrentStep] = useState(0);

  const saveSubmission = (results) => {
    const submissions = JSON.parse(localStorage.getItem('cb_submissions') || '[]');
    const id = Date.now().toString();
    const newSubmission = {
      id,
      date: new Date().toISOString(),
      businessInfo,
      answers,
      results
    };
    
    const updatedSubmissions = [newSubmission, ...submissions];
    localStorage.setItem('cb_submissions', JSON.stringify(updatedSubmissions));
    return id; // Retornamos el ID para poder navegar a él
  };

  const resetAssessment = () => {
    setBusinessInfo(null);
    setAnswers({});
    setCurrentStep(0);
  };

  return (
    <AssessmentContext.Provider value={{
      businessInfo, 
      setBusinessInfo, 
      answers, 
      setAnswers, 
      currentStep, 
      setCurrentStep, 
      saveSubmission, 
      resetAssessment
    }}>
      {children}
    </AssessmentContext.Provider>
  );
};